import React from 'react';
import { motion } from 'framer-motion';
import { useChangeDocumentTitle } from '../../helpers/useChangeDocumentTitle';
import { welcomeAnim } from '../Welcome/Welcome.anim';
export default function Projects({ pageTitle }) {
	useChangeDocumentTitle(pageTitle);

	return (
		<motion.div className='loader'
			variants={welcomeAnim}
			initial='init'
			animate='anim'
			exit='end'
		>
			<span>Updating soon....</span>
		</motion.div>
		// <h1>Updating soon....</h1>
		// <motion.section className='projects' variants={projectsAnim} initial='init' animate='anim' exit='end'>
		// 	<ProjectsSlider category='WEB DEV' data={web} />
		// 	<ProjectsSlider category='GAME DEV' data={game} />
		// 	<ProjectsSlider category='DESIGN' data={design} />
		// </motion.section>
	);
}
